import moment, { type Moment, type MomentInput } from 'moment';

const isToday = (date: Moment) => {
  const now = moment();
  return (
    date.date() === now.date() &&
    date.month() === now.month() &&
    date.year() === now.year()
  );
};

export const getNow = (): string => moment().toISOString();

export const formatDate = (date: MomentInput): string => {
  const d = moment.utc(date).local();

  if (!isToday(d)) {
    return d.format('D MMM');
  }

  return d.format('H:mm');
};

export const shortFormat = (date: MomentInput): string =>
  moment.utc(date).local().format('D.MM.YY');

export const formatDateWithoutSeconds = (date: MomentInput): string =>
  moment(date).format('DD MMMM YYYY LT');

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

export const checkIsISODate = (str: string) => ISO_DATE_REGEX.test(str);
